import RequestStatus from "../model/RequestStatus";
import {
    GetRevisionListQueryComplete,
    REVISION_LIST_QUERY_FAILED,
    REVISION_LIST_QUERY_START,
    REVISION_LIST_QUERY_SUCCESS
} from "src/actions/RevisionListQueryAction";
import {GetRevisionListQueryResponse} from "src/model/Revision";

const initialState: GetRevisionListQueryResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export default (
    state: GetRevisionListQueryResponse = initialState,
    action: GetRevisionListQueryComplete
): GetRevisionListQueryResponse => {
    switch (action.type) {
        case REVISION_LIST_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                data: null,
            };
        case REVISION_LIST_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: action.revisionList,
            };
        case REVISION_LIST_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
            };
        default:
            return state;
    }
};
